/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {
		constructor() {
			super();
			this.pageHeight = window.innerHeight;
		}

		connectedCallback() {
			this.events = new AbortController();
			this.querySelector('button').addEventListener('click', this.onClick, { signal: this.events.signal });
			window.addEventListener('scroll', () => this.checkVisible(), { passive: true, signal: this.events.signal });
			window.addEventListener('resize', () => this.checkVisible(), { signal: this.events.signal });
			this.checkVisible();
		}
		disconnectedCallback() { this.events.abort(); }

		checkVisible(event) {
			window.requestAnimationFrame(() => {
				let y = window.scrollY;
				this.inert = y <= window.innerHeight;
				if (!this.inert) {
					this.classList.add('back-to-top--active');
				} else {
					this.classList.remove('back-to-top--active');
				}
			});
		}

		onClick() {
			const target = document.querySelector('.screen-reader-shortcut') || document.getElementById('main-content');
			target?.focus({ preventScroll: true });
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
			});
		}
	}
	customElements.define('back-to-top', BackToTop);
}
